enum Sections {
  orderingCard = 'orderingCard',
  spending = 'spending',
  earnings = 'earnings',
  security = 'security',
}

enum Topics {
  multipleCards = 'multipleCards',
  monthlyFee = 'monthlyFee',
  creditScore = 'creditScore',
  cashbackEarnt = 'cashbackEarnt',
  mobilePay = 'mobilePay',
  useAbroad = 'useAbroad',
  retailers = 'retailers',
  cancelation = 'cancelation',
  cashbackEveryTime = 'cashbackEveryTime',
  monthlyLimit = 'monthlyLimit',
  cashbackToBankAccount = 'cashbackToBankAccount',
  cashbackWithdraw = 'cashbackWithdraw',
  howSecure = 'howSecure',
  lostCard = 'lostCard',
}

export { Topics, Sections };
